import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import baseStyles from '../../../ElementControlsStyles';
import { CustomSvgIconButton } from 'crazyEditor/components/EditorUI/BaseUI/index';
import { BasePopoverPanel } from 'crazyEditor/components/EditorUI/BaseUI/index';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import { sendToFront, sendBackward, sendForward, sendToBack } from 'crazyEditor/redux/modules/element/actions/elementPropsActions';
import * as Colors from 'material-ui/styles/colors';

@connect(
  false,
  {sendToFront, sendBackward, sendForward, sendToBack, closeLazyPanel}
)
@Radium
export default class ArrangeControlPanel extends Component {
  onCancel = () => {
    const { closeLazyPanel, panelName } = this.props;
    closeLazyPanel(panelName);
  };

  render() {
    const { open, panelName, anchorEl, panelProps, sendToFront, sendBackward, sendForward, sendToBack } = this.props;
    const { selectedElementIds, viewMode } = panelProps;
    return (
      <BasePopoverPanel
        panelName={panelName}
        anchorEl={anchorEl}
        open={open}
        onRequestClose={this.onCancel}
        popoverProps={{
          anchorOrigin: {horizontal: 'right', vertical: 'bottom'},
          targetOrigin: {horizontal: 'right', vertical: 'top'}
        }}
        style={{padding: '20px'}}
      >
        <div style={baseStyles.menuPanelTitle}>ARRANGE</div>
        <div style={baseStyles.menuPanelBody}>
          <ul style={baseStyles.menuPanelBodyList}>
            <li style={baseStyles.menuPanelBodyListItem}>
              <CustomSvgIconButton
                iconColor={Colors.grey700}
                iconPath="M2,2H16V16H2V2M22,8V22H8V18H10V20H20V10H18V8H22Z"
                tooltip="Send forward"
                onClick={() => sendForward(viewMode, selectedElementIds)}
                tooltipPosition="top-center"
              />
            </li>
            <li style={baseStyles.menuPanelBodyListItem}>
              <CustomSvgIconButton
                iconColor={Colors.grey700}
                iconPath="M2,2H16V16H2V2M22,8V22H8V18H18V8H22M4,4V14H14V4H4Z"
                tooltip="Send backward"
                onClick={() => sendBackward(viewMode, selectedElementIds)}
                tooltipPosition="top-center"
              />
            </li>
          </ul>
          <ul style={baseStyles.menuPanelBodyList}>
            <li style={baseStyles.menuPanelBodyListItem}>
              <CustomSvgIconButton
                iconColor={Colors.grey700}
                iconPath="M2,2H11V6H9V4H4V9H6V11H2V2M22,13V22H13V18H15V20H20V15H18V13H22M8,8H16V16H8V8Z"
                tooltip="Send to front"
                onClick={() => sendToFront(viewMode, selectedElementIds)}
              />
            </li>
            <li style={baseStyles.menuPanelBodyListItem}>
              <CustomSvgIconButton
                iconColor={Colors.grey700}
                iconPath="M2,2H11V11H2V2M9,4H4V9H9V4M22,13V22H13V13H22M15,20H20V15H15V20M16,8V11H13V8H16M11,16H8V13H11V16Z"
                tooltip="Send to back"
                onClick={() => sendToBack(viewMode, selectedElementIds)}
              />
            </li>
          </ul>
        </div>
      </BasePopoverPanel>
    );
  }
}

ArrangeControlPanel.propTypes = {
  panelName: PropTypes.string.isRequired,
  anchorEl: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  panelProps: PropTypes.shape({
    selectedElementIds: PropTypes.array.isRequired,
    viewMode: PropTypes.string.isRequired
  })
};
